export default "__VITE_ASSET__B$o6PWX5__"